import { render, staticRenderFns } from "./DetermineAnAmountOwingForExpenses.vue?vue&type=template&id=152b6eae"
import script from "./DetermineAnAmountOwingForExpenses.vue?vue&type=script&lang=ts"
export * from "./DetermineAnAmountOwingForExpenses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports